/** Central spacing scale. Import SPACING wherever a margin/padding tuple is needed. */
export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  xxxl: 32,
  huge: 40,
  giant: 48,
};

export const PAGE_MARGINS: [number, number, number, number] = [40, 56, 40, 48];
